<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)"
      v-on:input="$emit('updateDialog', false)" max-width="750px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name
          }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->

            <div class="row">
              <div class="col-md-6">
                <v-text-field label="id" v-model="item.id" v-show="false" required></v-text-field>

                <v-text-field data-vv-as="nombre" :label="$t('Nombre')" name="nameSubClient"
                  v-model="item.nameSubClient" v-validate="'required'" :disabled="isViewModal()"></v-text-field>
                <span class="red--text">{{ errors.first("nameSubClient") }}</span>

                <v-text-field data-vv-as="cuit" label="Cuit*" name="cuit" v-model="item.cuit"
                  :disabled="isViewModal()"></v-text-field>
                <span class="red--text">{{ errors.first("cuit") }}</span>

                <v-text-field data-vv-as="telefono" :label="$t('Telefono')" name="telefono"
                  v-model="item.subClientTelephone" :disabled="isViewModal()"> </v-text-field>
                <span class="red--text">{{ errors.first("telefono") }}</span>

                <v-text-field data-vv-as="email" label="Email*" name="email" v-model="item.subClientEmail"
                  :disabled="isViewModal()"> </v-text-field>
                <span class="red--text">{{ errors.first("email") }}</span>

                <v-text-field data-vv-as="contacto" label="Contacto*" name="contacto" v-model="item.contact"
                  :disabled="isViewModal()"> </v-text-field>
                <span class="red--text">{{ errors.first("contacto") }}</span>

                <v-checkbox label="Activo" v-model="item.isActive"></v-checkbox>
              </div>
              <div class="col-md-6">
                <v-text-field data-vv-as="externalCode" :label="$t('Codigo_externo')" name="email"
                  v-model="item.externalCode" :disabled="isViewModal()"> </v-text-field>
                <span class="red--text">{{ errors.first("email") }}</span>
                <v-combobox v-model="item.country" data-vv-as="pais" name="pais" item-text="name" item-value="id"
                  :items="countries" label="Pais*" autocomplete="off" v-validate="'required'" :disabled="isViewModal()"
                  @change="loadProvincies(item.country.id)"></v-combobox>
                <span class="red--text">{{ errors.first("pais") }}</span>

                <v-combobox v-model="item.province" data-vv-as="provincia" name="provincia" item-text="name"
                  item-value="id" :items="provinces" label="Provincia*" autocomplete="off" v-validate="'required'"
                  :disabled="isViewModal()" @change="loadLocalities(item.province.id)"></v-combobox>
                <span class="red--text">{{ errors.first("provincia") }}</span>

                <v-combobox v-model="item.locality" data-vv-as="localidad" name="localidad" item-text="name"
                  item-value="id" :items="localities" label="Localidad*" autocomplete="off" v-validate="'required'"
                  :disabled="isViewModal()"></v-combobox>
                <span class="red--text">{{ errors.first("localidad") }}</span>

                <v-text-field data-vv-as="direccion" :label="$t('Direccion')" name="direccion"
                  v-model="item.subClientAddress" v-validate="'required'" :disabled="isViewModal()"> </v-text-field>
                <span class="red--text">{{ errors.first("direccion") }}</span>

                <v-checkbox label="Notificar remitos en Ruta" v-model="item.communicationEnabled" persistent-hint
                  hint="Al tildar esta opcion se envia un email al subcliente con los remitos de su viaje."></v-checkbox>
              </div>
            </div>

            <!-- Horarios de Entrega y Tiempo de Descarga -->
            <div class="row mt-4">
              <div class="col-md-12">
                <h3 class="subtitle-1 mb-2">Horarios de Entrega</h3>
              </div>
              <div class="col-md-6">
                <v-text-field
                  v-model="item.deliveryTimeFrom1"
                  label="Horario Desde 1"
                  type="time"
                  :disabled="isViewModal()"
                ></v-text-field>
              </div>
              <div class="col-md-6">
                <v-text-field
                  v-model="item.deliveryTimeTo1"
                  label="Horario Hasta 1"
                  type="time"
                  :disabled="isViewModal()"
                ></v-text-field>
              </div>
              <div class="col-md-6">
                <v-text-field
                  v-model="item.deliveryTimeFrom2"
                  label="Horario Desde 2"
                  type="time"
                  :disabled="isViewModal()"
                ></v-text-field>
              </div>
              <div class="col-md-6">
                <v-text-field
                  v-model="item.deliveryTimeTo2"
                  label="Horario Hasta 2"
                  type="time"
                  :disabled="isViewModal()"
                ></v-text-field>
              </div>
              <div class="col-md-6">
                <v-text-field data-vv-as="tiempo de descarga" label="Tiempo de Descarga (minutos)" name="unloadingTime"
                  v-model.number="item.unloadingTime" type="number" :disabled="isViewModal()"></v-text-field>
                <span class="red--text">{{ errors.first("unloadingTime") }}</span>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">{{ $t("Cerrar") }}</v-btn>
            <v-btn v-if="!isViewModal()" color="success" text type="submit">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { countryService } from "@/libs/ws/countryService";
export default {
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      countries: [],
      provinces: [],
      localities: [],
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
      if (this.dialog) {
        if (this.item.id != "") {
          if (this.item.country != "") {
            this.loadProvincies(this.item.country.id);
          }
          if (this.item.province != "") {
            this.loadLocalities(this.item.province.id);
          }
          // Convertir tiempos del backend (HH:mm:ss) a formato del picker (HH:mm)
          if (this.item.deliveryTimeFrom1 && this.item.deliveryTimeFrom1.length > 5) {
            this.item.deliveryTimeFrom1 = this.item.deliveryTimeFrom1.substring(0, 5);
          }
          if (this.item.deliveryTimeTo1 && this.item.deliveryTimeTo1.length > 5) {
            this.item.deliveryTimeTo1 = this.item.deliveryTimeTo1.substring(0, 5);
          }
          if (this.item.deliveryTimeFrom2 && this.item.deliveryTimeFrom2.length > 5) {
            this.item.deliveryTimeFrom2 = this.item.deliveryTimeFrom2.substring(0, 5);
          }
          if (this.item.deliveryTimeTo2 && this.item.deliveryTimeTo2.length > 5) {
            this.item.deliveryTimeTo2 = this.item.deliveryTimeTo2.substring(0, 5);
          }
        } else {
          this.localities = [];
          this.provinces = [];
        }
      }
    },
  },
  mounted() {
    this.loadCountries();
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    formatTimeForBackend(time) {
      // Convierte HH:mm a HH:mm:ss
      if (time && time.length === 5) {
        return time + ":00";
      }
      return time;
    },
    loadCountries() {
      countryService
        .getAll()
        .then((response) => {
          this.countries = response.countries;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadProvincies(country) {
      countryService
        .getAllProvince(country)
        .then((response) => {
          if (this.item.id == "") {
            this.item.province = "";
            this.item.locality = "";
          }
          this.provinces = response.province;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadLocalities(province) {
      countryService
        .getAllLocality(province)
        .then((response) => {
          if (this.item.id == "") {
            this.item.locality = "";
          }
          this.localities = response.locality;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    createItem() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          // Formatear los tiempos antes de enviar al backend
          const itemToSend = {
            ...this.item,
            deliveryTimeFrom1: this.formatTimeForBackend(this.item.deliveryTimeFrom1),
            deliveryTimeTo1: this.formatTimeForBackend(this.item.deliveryTimeTo1),
            deliveryTimeFrom2: this.formatTimeForBackend(this.item.deliveryTimeFrom2),
            deliveryTimeTo2: this.formatTimeForBackend(this.item.deliveryTimeTo2),
          };

          if (this.item.id > 0) {
            this.service
              .update(itemToSend)
              .then((response) => {
                if (response.id > 0) {
                  this.$toast.success(this.$t("se_actualizo_ok"), "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else this.$toast.error(response.title, "Error");
              })
              .catch((response) => {
                this.$toast.error(response.title, "Error");
              });
          } else {
            this.service
              .create(itemToSend)
              .then((response) => {
                if (response.id > 0) {
                  this.$toast.success(this.$t("se_creo_ok"), "OK");
                  this.$emit("updateDialog", false);
                  this.$emit("loadList");
                } else this.$toast.error(response.title, "Error");
              })
              .catch((response) => {
                this.$toast.error(response.title, "Error");
              });
          }
        }
      });
    },
  },
};
</script>
